// extracted by mini-css-extract-plugin
module.exports = {"registerBtn":"RegisterForm_registerBtn__Iujrb","custom":"RegisterForm_custom__ti0gl","goBackBtn":"RegisterForm_goBackBtn__OMbmk"};